export default "__VITE_ASSET__B13QPIII__"